import { SheetModal } from './SheetModal';
import { AiUnderwritingGuidanceResultComponent } from './AiUnderwritingGuidanceResultComponent';

export const OpportunityAIUnderwritingGuidanceSheet = ({
  parsedResults,
  isOpen,
  onClose,
}: {
  parsedResults: {
    eligibilityOverview: {
      status: string;
      content: string[];
    };
    flaggedItems: string[];
    recommendations: string[];
  } | null;
  isOpen: boolean;
  onClose: () => void;
}) => {
  return (
    <SheetModal
      open={isOpen}
      onClose={onClose}
      title="Initial AI Underwriting Preview"
      subTitle="AI-powered analysis of underwriting factors"
      modal={true}
      className="sm:min-w-[55%] md:min-w-[550px] lg:min-w-[500px]"
    >
      <div className="flex min-h-full flex-1 flex-col overflow-auto">
        <div className="flex flex-1 flex-col py-4 ">
          {/* Results Display */}
          {parsedResults && <AiUnderwritingGuidanceResultComponent parsedResults={parsedResults} />}
        </div>
      </div>
    </SheetModal>
  );
};
